import { defineMessages } from 'react-intl';

const scope = 'cb.screens.SuccessfulSignUp';

export default defineMessages({
  premiumUpgrade: {
    id: `${scope}.premiumUpgrade`,
    defaultMessage: 'Upgrade to Premium',
  },
  premiumPrice: {
    id: `${scope}.premiumPrice`,
    defaultMessage: 'Just $12/year!',
  },
  redeemUnlimitedCoupons: {
    id: `${scope}.redeemUnlimitedCoupons`,
    defaultMessage: 'Redeem Unlimited Coupons',
  },
  redeemLimitFreePlan: {
    id: `${scope}.redeemLimitFreePlan`,
    defaultMessage: 'Redeem 10 Coupons/month on Free Plan',
  },
  redeemPoints: {
    id: `${scope}.redeemPoints`,
    defaultMessage: 'Redeem Points',
  },
  unlockPremiumCoupons: {
    id: `${scope}.unlockPremiumCoupons`,
    defaultMessage: 'Unlock Premium Coupons',
  },
  notNow: {
    id: `${scope}.notNow`,
    defaultMessage: 'Not Now',
  },
  getPremium: {
    id: `${scope}.getPremium`,
    defaultMessage: 'Get Premium',
  },
});
